import '../style.scss';
import { Button, ButtonFill, ButtonSize } from 'views/mutual/button';
import { Caption } from 'views/mutual/caption';
import { useConsentConfirm } from './hooks';
import { useCustomLocationName } from 'views/mutual/location/hooks';
import PDFViewer from 'views/mutual/pdfViewer'
import { LoadingContainer } from 'views/mutual/loading';
import { CheckInput } from 'views/templates/module/checkInput';

export const ConsentConfirm = () => {
  const props = useConsentConfirm();
  useCustomLocationName('口座開設');
  
  if(props.fileData != null){
    return (
      <div className='accountOpenTemplate_description'>        
        <Caption label="一般投資家への移行" />
        <LoadingContainer isLoading={props.fileData.fetching}>
        <div>
              <PDFViewer file={props.fileData.data?.GetPdfInfo?.PdfData}/>
            </div>  
          <div className="accountOpenTemplate_button">                             
            <Button
              label='ダウンロード'                       
              children={
                <div style={{
                  textAlign : 'center',
                  fontSize : '0.7rem',
                }}>
                  ※お手続きを進める場合は、必ずダウンロードを完了させてください。
                </div>
              }
              buttonFill={ButtonFill.black}
              buttonSize={ButtonSize.medium}
              {...props.downLoadProps}
            />            
            <CheckInput
                name="OfferPDFDownload"
                label={'特定投資家以外の顧客としての取り扱い承諾書をダウンロードしました'}
                {...props.checkBoxProps}
              />

            <Button
              label={'申込内容の確認へ進む'}
              buttonFill={ButtonFill.black}
              buttonSize={ButtonSize.medium}              
              {...props.nextProps}
            />
            <Button
              label="前の画面に戻る"
              buttonFill={ButtonFill.link}
              buttonSize={ButtonSize.small}
              {...props.backProps}
            />
          </div>                      
        </LoadingContainer>          
      </div>    
    );
  }
};
